import React from 'react'

import { useSessionPermission } from '@btime/react-session'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'
import { useOpenDynamicServiceOrdersModal } from '../../../utils/routes/modals/modalsActions'

const AddNewButton = () => {
  const hasAddPermission = useSessionPermission('createDynamicServiceOrder')
  const openDynamicServiceOrders = useOpenDynamicServiceOrdersModal()

  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={openDynamicServiceOrders} />
}

export default AddNewButton
